export default "//static.tradera.net/touchweb/static/output/images/swish_horizontal.52dbe256.svg";